import {IConfigurationEvaluationContext} from '../configuration-evaluation-context/configuration-evaluation-context.interface';
import {IPropertyEvaluator} from './property-evaluator.interface';
import {IValueEvaluator} from '../value-evaluators/value-evaluator.interface/value-evaluator.interface';



export class PropertyEvaluator implements IPropertyEvaluator {
  constructor(private _propertyName: string, private _valueEvaluator: IValueEvaluator) {

  }

  get propertyName(): string {
    return this._propertyName;
  }

  evaluate(context: IConfigurationEvaluationContext): any {

    let propertyContext = context.createPropertyContext(this.propertyName);

    try {
      return this._valueEvaluator.evaluate(propertyContext);
    } catch (err) {
      throw new Error(`Failed to evaluate property ${propertyContext.getCurrentPropertyPath()}; ${err}`);
    }

  }
}
